


























































































import {
  computed,
  defineComponent, PropType, Ref, ref, watch,
} from 'vue';

import api from '@/api';

export default defineComponent({
  props: {
    selection: {
      type: Array as PropType<string[]>,
      required: true,
    },

    workspace: {
      type: String as PropType<string>,
      required: true,
    },

    downloadType: {
      type: String as PropType<string>,
      required: true,
    },
  },

  setup(props, { emit }) {
    const dialog = ref(false);
    const disabled = ref(false);
    const timeout: Ref<number | undefined> = ref(undefined);
    const loading = ref(false);

    const plural = computed(() => (props.selection.length > 1 ? 's' : ''));
    const nonZeroSelection = computed(() => props.selection.length > 0);
    const downloadEndpoint = computed(() => {
      switch (props.downloadType) {
        case 'table':
          return api.downloadTable.bind(api);
        case 'network':
        default:
          return api.downloadNetwork.bind(api);
      }
    });

    watch(dialog, () => {
      if (!dialog.value) {
        emit('closed');
      }
    });

    async function execute() {
      loading.value = true;

      const downloads = await Promise.all(props.selection.map(async (name) => {
        const { data, headers: { 'content-type': contentType } } = await downloadEndpoint.value(props.workspace, name);
        const blobData = data instanceof Object ? JSON.stringify(data, null, 2) : data;
        const blob = new Blob([blobData], { type: contentType });

        const extension = contentType.split('/')[1];
        const filename = `${name}.${extension}`;
        const link = document.createElement('a');

        link.href = URL.createObjectURL(blob);
        link.download = filename;

        return link;
      }));

      downloads.forEach((link) => {
        link.click();
        URL.revokeObjectURL(link.href);
      });

      emit('downloaded', props.selection);
      loading.value = false;
      dialog.value = false;
    }

    return {
      dialog,
      disabled,
      timeout,
      loading,
      plural,
      nonZeroSelection,
      execute,
    };
  },
});
